import { defineStore } from "pinia";
import { fetchInvocationDetails, fetchInvocationJobsSummary, fetchInvocationStep, } from "@/api/invocations";
import { useKeyedCache } from "@/composables/keyedCache";
export const useInvocationStore = defineStore("invocationStore", () => {
    const { getItemById: getInvocationById, fetchItemById: fetchInvocationForId } = useKeyedCache(fetchInvocationDetails);
    const { getItemById: getInvocationJobsSummaryById, fetchItemById: fetchInvocationJobsSummaryForId } = useKeyedCache(fetchInvocationJobsSummary);
    const { getItemById: getInvocationStepById, fetchItemById: fetchInvocationStepById } = useKeyedCache(fetchInvocationStep);
    return {
        getInvocationById,
        fetchInvocationForId,
        getInvocationJobsSummaryById,
        fetchInvocationJobsSummaryForId,
        getInvocationStepById,
        fetchInvocationStepById,
    };
});
